import { render, staticRenderFns } from "./banjiSjDecSec.vue?vue&type=template&id=229549fb&scoped=true"
import script from "./banjiSjDecSec.vue?vue&type=script&lang=js"
export * from "./banjiSjDecSec.vue?vue&type=script&lang=js"
import style0 from "./banjiSjDecSec.vue?vue&type=style&index=0&id=229549fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229549fb",
  null
  
)

export default component.exports